// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5676":"7b7aa377007623f9","8977":"218140a328897e4d"}[chunkId] + ".css";
};